document.addEventListener("DOMContentLoaded", function () {
  // bag page: "remove" zeroes the qty field and submits the cart form
  document.querySelectorAll(".bag-line-remove").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.dataset.removeKey;
      var input = document.getElementById("bag-qty-" + key);
      if (!input) return;
      input.value = 0;
      var form = btn.closest("form");
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  var grid = document.getElementById("grid");
  if (!grid) return;

  var cells = [].slice.call(grid.querySelectorAll(".cell"));
  var clearBtn = document.getElementById("clear");
  var count = document.getElementById("count");
  var chips = [].slice.call(document.querySelectorAll(".chip"));
  var picked = [];

  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function applyFilter() {
    var shown = 0;
    var pending = 0;

    cells.forEach(function (cell) {
      var stock = (cell.dataset.stock || "").split(",").filter(Boolean);
      var productAvailable = cell.dataset.productAvailable === "true";
      var isPending = stock.length === 0;
      var match =
        picked.length === 0 ||
        stock.some(function (s) {
          return picked.indexOf(s) > -1;
        });

      cell.hidden = !match;

      if (match) {
        if (isPending && !productAvailable) {
          pending++;
        } else {
          shown++;
        }
      }

      cell.querySelectorAll(".run b").forEach(function (b) {
        if (picked.indexOf(b.dataset.s) > -1) {
          b.classList.add("hit");
        } else {
          b.classList.remove("hit");
        }
      });
    });

    if (clearBtn) clearBtn.hidden = picked.length === 0;

    if (count) {
      count.textContent = picked.length
        ? pad(shown) + " match " + picked.join("/")
        : pad(shown) + " in stock" + (pending ? " / " + pad(pending) + " pending" : "");
    }

    var empty = grid.querySelector(".empty-filtered");
    if (shown === 0 && pending === 0 && cells.length > 0) {
      if (!empty) {
        empty = document.createElement("div");
        empty.className = "empty empty-filtered";
        empty.textContent = "nothing in that size \u2014 try the list";
        grid.appendChild(empty);
      }
    } else if (empty) {
      empty.remove();
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      var s = chip.dataset.size;
      var i = picked.indexOf(s);
      if (i > -1) {
        picked.splice(i, 1);
        chip.setAttribute("aria-pressed", "false");
      } else {
        picked.push(s);
        chip.setAttribute("aria-pressed", "true");
      }
      applyFilter();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      picked.length = 0;
      chips.forEach(function (c) {
        c.setAttribute("aria-pressed", "false");
      });
      applyFilter();
    });
  }

  applyFilter();

  // per-cell: spec toggle, size selection, add-to-bag
  cells.forEach(function (cell) {
    var toggle = cell.querySelector(".toggle");

    function flip() {
      var open = cell.classList.toggle("open");
      if (toggle) {
        toggle.textContent = open ? "\u2212 size" : "+ size";
        toggle.setAttribute("aria-expanded", String(open));
      }
    }

    if (toggle) toggle.addEventListener("click", flip);

    var sizeButtons = [].slice.call(cell.querySelectorAll(".sz"));
    sizeButtons.forEach(function (b) {
      b.addEventListener("click", function () {
        if (b.disabled) return;
        sizeButtons.forEach(function (o) {
          o.setAttribute("aria-pressed", "false");
        });
        b.setAttribute("aria-pressed", "true");
      });
    });

    var buy = cell.querySelector(".buy[data-product-form]");
    if (!buy) return;

    buy.addEventListener("click", function () {
      var variantId = buy.dataset.defaultVariantId;
      var isSingle = buy.dataset.singleVariant === "true";

      if (!isSingle) {
        var selected = cell.querySelector(".sz[aria-pressed='true']");
        if (!selected) {
          if (!cell.classList.contains("open")) flip();
          buy.textContent = "pick a size";
          setTimeout(function () {
            buy.textContent = "add to bag";
          }, 1400);
          return;
        }
        variantId = selected.dataset.variantId;
      }

      var originalText = buy.textContent;
      buy.disabled = true;
      buy.textContent = "adding\u2026";

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + "cart/add.js"
        : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error("add to cart failed");
          return res.json();
        })
        .then(function () {
          buy.textContent = "added";
          return fetch("/cart.js");
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var bagLink = document.querySelector(".cart-link");
          if (bagLink) bagLink.textContent = "bag (" + cart.item_count + ")";
          var sidebarBag = document.querySelector(".side .nav a[href*='/cart']");
          if (sidebarBag) {
            sidebarBag.textContent =
              cart.item_count + (cart.item_count === 1 ? " item" : " items") + " \u2014 view bag";
          }
        })
        .catch(function () {
          buy.textContent = "try again";
        })
        .finally(function () {
          setTimeout(function () {
            buy.disabled = false;
            buy.textContent = originalText;
          }, 1400);
        });
    });
  });
});
